/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ios': {
    width: 12,
    height: 15,
    viewBox: '0 0 12 15',
    data: '<path pid="0" d="M10.009 8.016c0-1.84 1.471-2.724 1.545-2.798-.883-1.25-2.207-1.398-2.649-1.47-1.104-.147-2.207.661-2.797.661-.59 0-1.471-.662-2.428-.662-1.25 0-2.354.737-3.018 1.84-1.25 2.208-.295 5.52.957 7.285.588.883 1.324 1.84 2.281 1.84.883 0 1.25-.588 2.355-.588 1.103 0 1.398.588 2.428.588.957 0 1.62-.883 2.207-1.766.737-1.03.958-1.986 1.03-2.06.003.074-1.911-.663-1.911-2.87zm-1.84-5.373c.515-.588.883-1.47.736-2.354-.736 0-1.62.516-2.133 1.104-.442.516-.883 1.399-.737 2.282.81-.002 1.62-.443 2.134-1.032z" _fill="#868586" fill-rule="nonzero"/>'
  }
})
